import { ReactNode } from "react"
import { CartPanel } from "./panels/CartPanel"
import { PlannerPanel } from "./panels/PlannerPanel"
import { AccountPanel } from "./panels/AccountPanel"
import { MainMenuPanel } from "./panels/MainMenuPanel"
import { WishlistShareButton } from "@features/wishlist/WishlistShareButton"

export type FlyingCarpetTabInfo = {
  title: string
  description?: string
  hasHeader?: boolean
  component: () => ReactNode
  widget?: () => ReactNode
}

export type FlyingCarpetTab = "cart" | "planner" | "account" | "menu"

export const FLYING_CARPET_PANELS: Record<FlyingCarpetTab, FlyingCarpetTabInfo> = {
  cart: {
    title: "Cart",
    description: "Manage your cart",
    hasHeader: true,
    component: CartPanel,
  },
  planner: {
    title: "Watchlist",
    description: "Manage your watchlist",
    hasHeader: true,
    component: PlannerPanel,
    widget: () => <WishlistShareButton />,
  },
  account: {
    title: "Account",
    description: "Sign into your account to keep track of your purchases, passes and watchlist.",
    hasHeader: true,
    component: AccountPanel,
  },
  menu: {
    title: "Menu",
    description: "Navigate the site",
    hasHeader: false,
    component: MainMenuPanel,
  },
}
